import type { ChatMessage } from './chatMessageViewTypes';

const mediaKind = (file: File): string => {
  const kind = file.type.split('/')[0] ?? '';
  if (kind === 'application' || kind === 'text') {
    return 'file';
  }
  return kind;
};

export const messageFromFile = (
  file: File,
  input: {
    duration: string;
    userId?: string | number;
    roomId: string | null;
    socketId: string | null;
    messageId: string;
  }
): { kind: string; message: ChatMessage } | null => {
  const kind = mediaKind(file);
  const shared = {
    user: { _id: input.userId },
    roomId: input.roomId,
    socketId: input.socketId,
    isSeen: false,
    uuid: input.messageId,
    createdAt: new Date(),
  };

  if (kind === 'video') {
    return {
      kind,
      message: { ...shared, type: 'video', video: URL.createObjectURL(file) },
    };
  }
  if (kind === 'image') {
    return {
      kind,
      message: {
        ...shared,
        type: 'image',
        image: URL.createObjectURL(file),
        imageName: file.name,
      },
    };
  }
  if (kind === 'audio') {
    return {
      kind,
      message: {
        ...shared,
        type: 'audio',
        audio: { duration: input.duration, uri: URL.createObjectURL(file) },
      },
    };
  }
  if (kind === 'file') {
    return {
      kind,
      message: {
        ...shared,
        type: 'file',
        file: {
          url: URL.createObjectURL(file),
          fileName: file.name,
          fileType: file.name.split('.')[1],
        },
      },
    };
  }
  return null;
};

export const applyUploadedLocation = (
  message: ChatMessage,
  kind: string,
  location: string
): void => {
  if (kind === 'file' && message.type === 'file' && message.file) {
    message.file.url = location;
    return;
  }
  if (kind === 'audio' && message.type === 'audio' && message.audio) {
    message.audio.uri = location;
    return;
  }
  if (message.type === 'video') {
    message.video = location;
    return;
  }
  if (message.type === 'image') {
    message.image = location;
  }
};
